import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Skeleton } from "antd-mobile";
import { Helmet } from "react-helmet";
import { getChunkByKey } from "../services/utils";
import Header from "../components/visual/header";
import Footer from "../components/visual/footer";

/**
 * Renders an HTML string inside a <p> tag.
 */
export const renderAsP = (htmlPart, className = "") => {
  return <p className={className} dangerouslySetInnerHTML={{ __html: htmlPart }} />;
};

/**
 * Renders an HTML string inside a <div> tag.
 */
export const renderAsDiv = (htmlPart) => {
  return htmlPart && <div dangerouslySetInnerHTML={{ __html: htmlPart }} />;
};

function ChunkPage(props) {
  const [chunk] = useState(props.chunkKey);
  const [text, setText] = useState("");
  const [loading, setLoading] = useState(true);

  let navigate = useNavigate();

  const back = () => {
    navigate(-1);
  };

  useEffect(() => {
    const fetchDataChunk = async (chunk) => {
      setLoading(true);
      try {
        const res = await getChunkByKey(chunk);
        setText(res.content);
      } catch (error) {
        console.log("Error fetching chunk");
      } finally {
        setLoading(false);
      }
    };

    if (chunk) fetchDataChunk(chunk);
  }, [chunk]);

  return (
    <>
      <Helmet>
        <title>{props.title} | littlecoders.dev. Aprende Python mientras organizas tu día</title>
        <link rel="canonical" href={props.path ? props.path : ""} />
        <meta name="description" content={props.title} />
      </Helmet>

      <Header />

      {/* Page Hero */}
      <div style={{ backgroundColor: "#eef3ff", padding: "60px 20px 40px", textAlign: "center" }}>
        <div className="container" style={{ maxWidth: "800px", margin: "0 auto" }}>
          <h1 style={{ fontSize: "2.5rem", fontWeight: "900", color: "#333", marginBottom: "10px" }}>
            {props.title}
          </h1>
          <hr style={{ width: "60px", border: "3px solid #5B88FA", borderRadius: "2px", margin: "20px auto 0" }} />
        </div>
      </div>

      {/* Content Area */}
      <div style={{ backgroundColor: "#fff", padding: "60px 20px", minHeight: "60vh" }}>
        <div
          className="col-md-8 offset-md-2 col-xs-12"
          style={{
            fontFamily: "'Poppins', sans-serif",
            fontSize: "1.05rem",
            color: "#444",
            lineHeight: "1.8",
          }}
        >
          {loading ? (
            <div style={{ padding: "20px 0" }}>
              <Skeleton animated style={{ marginBottom: 16, height: 24 }} />
              <Skeleton animated style={{ marginBottom: 16, height: 24 }} />
              <Skeleton animated style={{ marginBottom: 16, height: 16, width: "70%" }} />
              <Skeleton animated style={{ marginBottom: 16, height: 24 }} />
              <Skeleton animated style={{ height: 16, width: "50%" }} />
            </div>
          ) : text ? (
            <div
              className="chunk-content"
              dangerouslySetInnerHTML={{ __html: text }}
              style={{
                lineHeight: "1.8",
              }}
            />
          ) : (
            <div style={{ textAlign: "center", padding: "60px 0", color: "#999" }}>
              <i className="fa-solid fa-triangle-exclamation" style={{ fontSize: "2.5rem", marginBottom: "15px" }}></i>
              <p style={{ fontSize: "1.1rem" }}>Contenido no disponible en este momento.</p>
            </div>
          )}

          {/* Back button */}
          {!loading && (
            <div style={{ marginTop: "50px" }}>
              <button
                onClick={back}
                style={{
                  backgroundColor: "transparent",
                  color: "#5B88FA",
                  border: "2px solid #5B88FA",
                  padding: "10px 25px",
                  borderRadius: "25px",
                  fontSize: "1rem",
                  fontWeight: "bold",
                  cursor: "pointer",
                  transition: "background-color 0.2s"
                }}
                onMouseOver={(e) => { e.target.style.backgroundColor = "#5B88FA"; e.target.style.color = "white"; }}
                onMouseOut={(e) => { e.target.style.backgroundColor = "transparent"; e.target.style.color = "#5B88FA"; }}
              >
                <i className="fa-solid fa-arrow-left me-2"></i>
                Volver atrás
              </button>
            </div>
          )}
        </div>
      </div>

      <Footer />
    </>
  );
}

export default ChunkPage;
